var map = {
	"./avatar-lucy-base-full.png": 72927,
	"./avatar-lucy-fall-full.png": 26987,
	"./avatar-lucy-spring-full.png": 95707,
	"./avatar-lucy-summer-full.png": 8123,
	"./avatar-lucy-travel-full.png": 81514,
	"./avatar-lucy-winter-full.png": 81655
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27862;